import { render, staticRenderFns } from "./XkcdComic.vue?vue&type=template&id=3e6023b5&scoped=true&"
import script from "./XkcdComic.vue?vue&type=script&lang=js&"
export * from "./XkcdComic.vue?vue&type=script&lang=js&"
import style0 from "./XkcdComic.vue?vue&type=style&index=0&id=3e6023b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6023b5",
  null
  
)

export default component.exports